import HTTP from "../../http";

const AUTH_ENDPOINT = "/auth";
const LOGIN_ENDPOINT = "/login";

export async function login(credentials) {
  return await HTTP.post(AUTH_ENDPOINT + LOGIN_ENDPOINT, credentials, {
    headers: { "Content-Type": "application/json" }
  });
}
